import { validatePresence, validateFormat } from 'ember-changeset-validations/validators';

export default {
  title: validatePresence({ presence: true, message: 'This is a required field' }),
  description: validatePresence({ presence: true, message: 'This is a required field' }),
  link: validateFormat({ type: 'url', message: 'Must be a valid URL', allowBlank: true }),
};
